<div class="container breathe mt-5">
  @for (extract of extracts; track extract; let i = $index) {
<div class="row">
    <div class="container-fluid">
      <div class="row">
        <h2 class="title" [id]="extract.name">{{ 'title.' + extract.title | translate }}</h2>
      </div>
      <div class="row">
        <div class="col-xl-6">
          @if (extract.type.toString() == 'DISTRIBUTION') {
<app-chart-distribution [extract]="extract" (updateRequest)="updateExtracts([$event])" [hideTitle]="true"></app-chart-distribution>
}
          @if (extract.type.toString() == 'TIMESERIES') {
<app-chart-timeseries [extract]="extract" (updateRequest)="updateExtracts([$event])" [hideTitle]="true"></app-chart-timeseries>
}
          @if (extract.type.toString() == 'COMPARISON') {
<app-chart-comparison
           
            [extract]="extract"
            (updateRequest)="updateExtracts([$event])"
            (typeChange)="onChartTypeChange(extract, $event)"
            [hideTitle]="true"></app-chart-comparison>
}
        </div>
        <div class="col-xl-6 p-3 info">
          <app-extract-info [extract]="extract"></app-extract-info>
        </div>
      </div>
      @if (i+1 !== extracts.length) {
<div class="row breathe">
        <div class="separator"></div>
      </div>
}
    </div>
  </div>
}
</div>
